import axios from "axios";

export interface IDocumentationForm {
  title?: string;
  description?: string;
  category: string;
  patient?: string;
  employee?: string;
}

interface PatientRowData {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export const getUsersPatients = async ({
  perPage,
  currentPage,
  searchValue,
}: {
  perPage: number;
  currentPage: number;
  searchValue: string;
}) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/user/patients?perPage=${perPage}&page=${currentPage}&search=${searchValue}`,
      {
        withCredentials: true,
      }
    )
    .then((response) => response.data);
};

export const getPatientDetails = async (id?: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/user/patients/${id}`, {
      withCredentials: true,
    })
    .then((response) => response.data.user);
};

export const setDocumentationForm = async (
  request: IDocumentationForm
): Promise<any> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/historical/documentation`,
    request,
    {
      withCredentials: true,
    }
  );
};

export const getDocumentationForm = async (
  patientId?: string,
  category?: string
): Promise<any> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/historical/documentation?id=${patientId}&category=${category}`,
    {
      withCredentials: true,
    }
  );
};

export const updateDocumentationForm = async (
  documentationId: string,
  updateRequest?: IDocumentationForm
): Promise<any> => {
  return axios.put(
    `${process.env.REACT_APP_API_URL}/historical/documentation/${documentationId}`,
    updateRequest,
    {
      withCredentials: true,
    }
  );
};

export const deleteDocumentationForm = async (documentationId: string) => {
  return axios.delete(
    `${process.env.REACT_APP_API_URL}/historical/documentation/${documentationId}`,
    {
      withCredentials: true,
    }
  );
};

export const editPatient = async (
  patientId: string,
  patient: PatientRowData
): Promise<any> => {
  return axios.patch(
    `${process.env.REACT_APP_API_URL}/user/patients/edit/${patientId}`,
    patient,
    {
      withCredentials: true,
    }
  );
};
